import { render } from "./GiftDetail.vue?vue&type=template&id=0e134da1"
import script from "./GiftDetail.vue?vue&type=script&lang=js"
export * from "./GiftDetail.vue?vue&type=script&lang=js"

import "./GiftDetail.vue?vue&type=style&index=0&id=0e134da1&lang=scss"
script.render = render

export default script